module.exports = __webpack_public_path__ + "static/media/bookmark-svgrepo-com (3).1efe302d.svg";